import React from 'react';
import { XCircle, AlertCircle } from 'lucide-react';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';

const ResultsDialog = ({ open, onOpenChange, inventoryResults }) => {
  const summary = inventoryResults?.summary ?? { expected: 0, found: 0, missing: 0, extra: 0 };
  const missingItems = inventoryResults?.missing_items ?? [];
  const extraItems = inventoryResults?.extra_items ?? [];

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-2xl">
        <DialogHeader><DialogTitle>Résultats de l&apos;inventaire</DialogTitle></DialogHeader>
        <div className="space-y-6">
          <div className="grid grid-cols-4 gap-4">
            {[
              { label: 'Attendus', value: summary.expected, cls: 'bg-slate-50 text-slate-900' },
              { label: 'Trouvés', value: summary.found, cls: 'bg-emerald-50 text-emerald-700' },
              { label: 'Manquants', value: summary.missing, cls: 'bg-rose-50 text-rose-700' },
              { label: 'Non attendus', value: summary.extra, cls: 'bg-amber-50 text-amber-700' },
            ].map(({ label, value, cls }) => (
              <div key={label} className={`p-4 rounded-lg ${cls} text-center`}>
                <p className="text-2xl font-bold">{value}</p>
                <p className="text-xs opacity-75">{label}</p>
              </div>
            ))}
          </div>

          {missingItems.length > 0 && (
            <div>
              <h4 className="font-medium text-slate-700 mb-2 flex items-center gap-2">
                <XCircle className="w-4 h-4 text-rose-600" />
                Mobilier manquant ({missingItems.length})
              </h4>
              <div className="max-h-48 overflow-y-auto space-y-2">
                {missingItems.map((item, idx) => (
                  <div key={idx} className="p-2 rounded bg-rose-50 text-sm">
                    <span className="font-mono">{item.code_barres}</span>
                    <span className="text-slate-500 ml-2">{item.marque} {item.modele}</span>
                  </div>
                ))}
              </div>
            </div>
          )}

          {extraItems.length > 0 && (
            <div>
              <h4 className="font-medium text-slate-700 mb-2 flex items-center gap-2">
                <AlertCircle className="w-4 h-4 text-amber-600" />
                Mobilier non attendu ({extraItems.length})
              </h4>
              <div className="max-h-48 overflow-y-auto space-y-2">
                {extraItems.map((item, idx) => (
                  <div key={idx} className="p-2 rounded bg-amber-50 text-sm">
                    <span className="font-mono">{item.code_barres}</span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Fermer</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ResultsDialog;
